<template>
  <div class="flex flex-col w-full h-full justify-center items-center bg-white">
    <loader />
  </div>
</template>

<script setup lang="ts">
import Session from 'supertokens-web-js/recipe/session';
import { AuthRouteNames, CustomerRouteNames } from '@app/router/route-names';
import { useRoute, useRouter } from 'vue-router';
import { AdminApi } from '@app/api/admin/admin-api';

const router = useRouter();
const route = useRoute();

const checkForSession = async () => {
  if (await Session.doesSessionExist()) {
    if (route.query.origin) {
      console.log(route.query.origin);
      await router.replace({ path: <string>route.query.origin });
    } else {
      const { redirect } = await AdminApi.getRedirect();
      if (redirect === 'admin') {
        await router.replace({ name: AuthRouteNames.AdminLogin });
      } else {
        await router.replace({ name: CustomerRouteNames.Home });
      }
    }
  } else {
    await router.replace({ name: AuthRouteNames.AdminLogin });
  }
};

checkForSession();
</script>

<style scoped lang="scss">
</style>
